import Toast from "../../../../common/core-ui/Toast";
import { useIntl } from "react-intl";

export const UpdateSuccessToast = ({ onClose }: { onClose?: () => void }) => {
  const intl = useIntl();

  return (
    <Toast
      onClose={onClose}
      type="success"
      title={intl.formatMessage({
        defaultMessage: "Library successfully updated.",
      })}
    />
  );
};

export const UpdateErrorToast = ({ onClose }: { onClose?: () => void }) => {
  const intl = useIntl();

  return (
    <Toast
      onClose={onClose}
      type="error"
      title={intl.formatMessage({
        defaultMessage:
          "Library could not be updated at this time. Please try again later.",
      })}
    />
  );
};
